import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import * as urlService from "../../view/urlService";

export const useAnalysisTableHelper = () => {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const hardReload = (props = {}) => {
        setConfig({
            ...config,
            selected: [],
            selectAll: false,
            hardReload: true,
            lastUpdated: Date.now(),
            ...props
        });
    }

    const onRuleNameClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('rule')
        })
    }

    const onDetailsClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('details')
        })
    }

    const onExpectedResultClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('expectedOutput')
        })
    }

    const onUserClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('user')
        })
    }

    const onSectionClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('sectionName')
        })
    }

    const onSubsectionClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('subsectionName')
        })
    }

    const onSeverityClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('severity')
        })
    }

    const onValidClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('valid')
        })
    }

    //TODO add on backend an remove comment
    const onGroupClick = () => {
        /* history.push({
             pathname: history.pathname,
             search: urlService.updateSort('group')
         })*/
    }

    return {
        hardReload, onRuleNameClick, onDetailsClick, onExpectedResultClick, onUserClick,
        onSectionClick, onSubsectionClick, onSeverityClick, onValidClick, onGroupClick
    }
}
